import { Sidebar } from "primereact/sidebar";
import InsightsContent from "./InsightsContent";

interface IInsightsSidebarProps {
    insightsOpen: boolean;
    setInsightsOpen: (isOpen: boolean) => void;
    setInvestorProfileOpen: (isOpen: boolean) => void;
}

export default function InsightsSidebar({ insightsOpen, setInsightsOpen, setInvestorProfileOpen }: IInsightsSidebarProps) { 
    return (
        <Sidebar visible={insightsOpen} onHide={() => setInsightsOpen(false)} position="right">
            <h2 className="m-0 mb-4">Insights da carteira</h2>
            <InsightsContent setInvestorProfileOpen={setInvestorProfileOpen} />
        </Sidebar>
    );
}
